import { Outlet } from 'react-router-dom';

export const CardsOutlet = () => <Outlet />;
